import { takeLatest, call, put } from 'redux-saga/effects';
import { saveEmail } from 'api';

import { showNotification } from 'components/Notification/actions';

import * as actions from './actions';

function* getHandl(action) {
  const { payload: { email } } = action;

  try {
    yield call(saveEmail, email);
    yield put(actions.toggleEmailHandl());

    yield put(showNotification({
      title: 'Email succesfully added'
    }));
  } catch (err) {
    console.log('ERR', err);
  }
}


export default function* () {
  yield takeLatest(
    actions.SAVE_EMAIL,
    getHandl
  );
}



// WEBPACK FOOTER //
// ./src/pages/Email/saga.js